import { TFunction } from 'i18next';
import autoTable from 'jspdf-autotable';
import { initializePDFDoc } from '../../common';
// eslint-disable-next-line no-restricted-imports
import moment from 'moment';
import { DefaultDateFormat } from '../../helpers/dates';

const PARENTS_COLUMNS = [
  { headerKey: 'familyDirectory.export.nameColumn', dataKey: 'studentName' },
  { headerKey: 'familyDirectory.export.roomColumn', dataKey: 'rooms' },
  { headerKey: 'familyDirectory.export.familyContactsColumn', dataKey: 'contacts' },
  { headerKey: 'familyDirectory.export.emailColumn', dataKey: 'email' },
  { headerKey: 'familyDirectory.export.phoneColumn', dataKey: 'phone' },
  { headerKey: 'familyDirectory.export.pickupColumn', dataKey: 'pickup' },
  { headerKey: 'familyDirectory.export.paymentColumn', dataKey: 'payment' },
  { headerKey: 'familyDirectory.export.autopayColumn', dataKey: 'autopay' },
  { headerKey: 'familyDirectory.export.mobileAppColumn', dataKey: 'app' },
  { headerKey: 'familyDirectory.export.inviteStatusColumn', dataKey: 'invite' },
];

export async function generateParentsListingPDF(studentsList: any, t: TFunction) {
  const selectedLocation = studentsList[0]?.locationName;
  const date = moment(new Date()).format(DefaultDateFormat);
  const filename = `Contact_list_${selectedLocation}_${date}.pdf`;
  const doc = initializePDFDoc(t('familyDirectory.export.documentTitle'), 'landscape');
  autoTable(doc, {
    columns: PARENTS_COLUMNS.map(({ headerKey, ...column }) => ({ ...column, header: t(headerKey) })),
    body: studentsList,
    startY: 45,
  });
  doc.setProperties({
    title: filename,
  });
  return { filename: filename, pdf: doc };
}
